// Module
var code = "<ib-ui-loading\n        view-title=\"'LOADING_REDIRECTION_TEXT'\"\n        type=\"'grey'\"\n        modifier=\"'ib-ui-loading--pinned-200'\">\n</ib-ui-loading>";
// Exports
module.exports = code;